import { RhIcon, RhSelectFormik } from "@rhythm-ui/react";
import React from "react";

import { Chip } from "../utils/Chip";

type setFormikFieldValueType = (
  field: string,
  value: any,
  shouldValidate?: boolean | undefined,
) => void;

const DataSelectFormik = ({
  values,
  valueKey,
  setFormikFieldValue,
  apiCall,
  isMulti,
  getOptionLabel,
  className,
  placeholder,
  creatable,
  onCreateOption,
  menuPlacement,
  getChipLabel,
  disableMenuPortal = false,
  hideSelectedOptionsChips = false,
}: {
  values: any;
  valueKey: any;
  setFormikFieldValue: setFormikFieldValueType;
  apiCall: (input: string, callback: any) => Promise<any>;
  isMulti?: boolean;
  getOptionLabel?: (data: any) => any;
  onCreateOption?: (data: any) => any;
  className?: string;
  placeholder?: string;
  creatable?: boolean;
  menuPlacement?: "top" | "auto" | "bottom" | undefined;
  getChipLabel?: (data: any) => any;
  disableMenuPortal?: boolean;
  hideSelectedOptionsChips?: boolean;
}) => {
  const debounce = (func: (...args: any[]) => Promise<any>, wait: number) => {
    let timeout: ReturnType<typeof setInterval> | undefined;
    return function executedFunction(...args: any[]) {
      const later = () => {
        timeout = undefined;
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };

  const loadOptions = debounce(apiCall, 700);

  const selectedValues = (values[valueKey] || []) as { id: number }[];

  const removeItemByID = (id: number) => {
    const newSelectedValues = selectedValues?.filter(
      (item: { id: number }) => item.id !== id,
    );
    if (typeof valueKey === "string")
      setFormikFieldValue(valueKey, newSelectedValues);
  };

  return (
    <>
      <RhSelectFormik
        instanceId={valueKey.toString()} //https://github.com/JedWatson/react-select/issues/2629
        isClearable={true}
        creatable={creatable}
        onCreateOption={onCreateOption}
        name={valueKey as string}
        placeholder={placeholder ?? "Search"}
        backspaceRemovesValue={false}
        getOptionValue={(data: any) => data?.id}
        getOptionLabel={
          getOptionLabel ? getOptionLabel : (data: any) => data?.name
        }
        getNewOptionData={(value, label) => ({
          id: value,
          name: label,
          isNew: true,
        })}
        isMulti={isMulti}
        hideSelectedOptions={isMulti}
        controlShouldRenderValue={!isMulti}
        async
        loadOptions={loadOptions}
        defaultOptions={true}
        className={className}
        menuPortalTarget={
          !disableMenuPortal &&
          typeof window !== "undefined" &&
          document.querySelector("#theme-provider")
        }
        menuPosition={"absolute"}
        // menuContainerStyle={{ top: "auto", bottom: "100%" }}
        menuPlacement={menuPlacement ?? "auto"}
      />
      {isMulti && !hideSelectedOptionsChips && (
        <div className="flex flex-wrap [&>*]:mb-2 [&>*]:mr-2">
          {selectedValues?.map((item: any) => {
            return (
              <Chip
                key={item?.id}
                shape={"circle"}
                size={"sm"}
                className="flex gap-tpico"
                onClick={() => removeItemByID(item?.id)}
                //   data-testid="added-location"
              >
                {getChipLabel ? getChipLabel(item) : item?.name}
                <RhIcon icon="tabler:x"></RhIcon>
              </Chip>
            );
          })}
        </div>
      )}
    </>
  );
};

export default DataSelectFormik;
